import { useRef, useState } from 'react';

import { Box, Paper } from '@mui/material';

import { useIsMobile } from '@@common';

import { BoxResizeHandle } from '../../common/components/BoxResizeHandle';
import PromptChat from '../../components/Chat/PromptChat';
import { PromptChatDraftRequest } from '../../components/Chat/PromptChat';
import { ChatMessage, PromptChatAdapter } from '../../components/Chat/PromptChatAdapter';

type PlanningChatPanelProps = {
	adapter: PromptChatAdapter;
	onComplete?: () => void | Promise<void>;
	onAssistantMessageReceived?: (message: ChatMessage) => void | Promise<void>;
	storySelected?: boolean;
	draftRequest?: PromptChatDraftRequest;
};

export default function PlanningChatPanel({ adapter, onComplete, onAssistantMessageReceived, storySelected = false, draftRequest }: PlanningChatPanelProps) {
	const [width, setWidth] = useState(380);
	const panelRef = useRef<HTMLDivElement>(null);
	const isMobile = useIsMobile();

	return (
		<Paper
			ref={panelRef}
			square
			sx={{
				position: 'relative',
				width: isMobile ? '100%' : width,
				height: { xs: 420, md: 'auto' },
				minHeight: 0,
				flexShrink: 0,
				display: 'flex',
				borderRight: { xs: 0, md: 1 },
				borderTop: { xs: 1, md: 0 },
				borderColor: 'divider',
			}}
		>
			{!isMobile && (
				<BoxResizeHandle
					position="right"
					width={width}
					setWidth={setWidth}
					panelRef={panelRef}
					storageKey="planningChatPanel.width"
					defaultWidth={380}
					minWidth={300}
					maxWidth={720}
					direction="left"
				/>
			)}
			<Box sx={{ display: 'flex', flex: 1, minWidth: 0, minHeight: 0 }}>
				<PromptChat
					adapter={adapter}
					emptyStateText={storySelected ? 'Refine this domain story with Randol.' : 'Explore requirements and domain stories with Randol.'}
					unavailableText="Sign in to plan with Randol."
					onComplete={onComplete}
					onAssistantMessageReceived={onAssistantMessageReceived}
					draftRequest={draftRequest}
				/>
			</Box>
		</Paper>
	);
}
